import { ILocationResponse, LocationResponse } from '@kcftech/prometheus-client';
import {
    QueryObserverOptions,
    QueryObserverResult,
    skipToken,
    useQuery,
} from '@tanstack/react-query';
import { dayMs, hourMs } from 'components/date_time/time';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

type QueryData = LocationResponse | undefined;
type QueryError = Partial<Error>;

export const locationQueryKey = 'location';

export function useLocation(
    id: string | undefined,
    options?: Omit<QueryObserverOptions<QueryData, QueryError>, 'queryKey' | 'queryFn'>,
): QueryObserverResult<ILocationResponse | undefined, Partial<Error>> {
    return useQuery<QueryData, QueryError>({
        queryKey: [locationQueryKey, id],
        queryFn: id ? () => sdClient.getLocation({ locationId: id }) : skipToken,
        gcTime: 7 * dayMs,
        staleTime: hourMs,
        ...options,
    });
}

export function invalidateLocation(id: string) {
    queryClient.invalidateQueries({
        queryKey: [locationQueryKey, id],
    });
}
